import Axios from "axios";

Axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
let token = sessionStorage.getItem("accessToken");
if (token && token != "") {
  token = token.replace(/\"/g, "");
  Axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

const webAPIURL = () => {
  let url = `/`;
  return url;
};

const instance = Axios.create({
  withCredentials: true,
  baseURL: webAPIURL(),
  timeout: 120000,
});

// // Axios.interceptors.request.use((request) => {
// //   if (localStorage.getItem("accessToken"))
// //     request.headers["Authorization"] = `Bearer ${localStorage.getItem(
// //       "accessToken"
// //     )}`;

//   return request;
// });

export default class APIHelper {
  static apiUrl() {
    return webAPIURL();
  }

  static get(url, headers = {}, obj) {
    return new Promise((resolve, reject) => {
      instance
        .get(url, { headers })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static post(
    url,
    obj,
    headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    params = {}
  ) {
    return new Promise((resolve, reject) => {
      instance
        .post(url, obj, { headers, params })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static delete(url) {
    return new Promise((resolve, reject) => {
      instance
        .delete(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
